import { createContext, useContext, useState } from 'react';
import type { PropsWithChildren } from 'react';
import type { GetFeatureFlagsResponse } from '../codegen/types';

export interface FeatureFlagsSimplifiedContext {
  isAuthRecaptchaEnabled: boolean;
  isKlarnaPdpEnabled: boolean;
  isProductStockCheckEnabled: boolean;
  isShowAddonsOnCartEnabled: boolean;
}

interface FeatureFlagsContext {
  featureFlags: GetFeatureFlagsResponse;
}

export const FeatureFlagsContext = createContext<FeatureFlagsSimplifiedContext>({
  isAuthRecaptchaEnabled: false,
  isKlarnaPdpEnabled: false,
  isProductStockCheckEnabled: false,
  isShowAddonsOnCartEnabled: false,
});

export function FeatureFlagsProvider({ children, featureFlags }: PropsWithChildren<FeatureFlagsContext>) {
  const [contextData] = useState<FeatureFlagsSimplifiedContext>({
    isAuthRecaptchaEnabled: featureFlags?.authRecaptcha?.enabled || false,
    isKlarnaPdpEnabled: featureFlags?.klarnaPdp?.enabled || false,
    isProductStockCheckEnabled: featureFlags?.productStockCheck?.enabled || false,
    isShowAddonsOnCartEnabled: featureFlags?.showAddonsOnCart?.enabled || false,
  });

  return <FeatureFlagsContext.Provider value={contextData}>{children}</FeatureFlagsContext.Provider>;
}

export function useFeatureFlagsContext() {
  const { isAuthRecaptchaEnabled, isKlarnaPdpEnabled, isProductStockCheckEnabled, isShowAddonsOnCartEnabled } =
    useContext(FeatureFlagsContext);

  return {
    isAuthRecaptchaEnabled,
    isKlarnaPdpEnabled,
    isProductStockCheckEnabled,
    isShowAddonsOnCartEnabled,
  };
}
